import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import origin from './origin'

export default function RedirectProxy() {
  const { pathname = '' } = useLocation()

  useEffect(() => {
    window.location.href = `${origin}${pathname}`
    // eslint-disable-next-line
  }, [])

  return null
}
